import { Record } from 'immutable'

export class TransportType extends Record({
    id: undefined,
    name: undefined,
    min_profit_percent: undefined,
    costs_fixed: undefined,
}) {}
